import { Locale as DateTimeLocale, de } from "date-fns/locale";

import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

export const SUPPORTED_LOCALES = {
	de_DE: { language: "de", country: "DE" }
} as const satisfies Record<string, Locale>;

export const DATE_TIME_LOCALES = {
	de_DE: de
} as const satisfies Record<keyof typeof SUPPORTED_LOCALES, DateTimeLocale>;

export const DEFAULT_LOCALE_KEY: keyof typeof SUPPORTED_LOCALES = "de_DE";

export const DEFAULT_LOCALE: Locale = SUPPORTED_LOCALES[DEFAULT_LOCALE_KEY];

export const DEFAULT_DATE_TIME_LOCALE: DateTimeLocale = DATE_TIME_LOCALES[DEFAULT_LOCALE_KEY];
